import React from "react";
import styled from "styled-components";
import { roundTo } from "../utils";

const Min = styled.div`
  background-color: #76b729;
  padding: 2px 10px;
  color: #fff;
  font-size: 12px;
  min-width: 53px;
  border-top-right-radius: 4px;
  font-family: Lato, sans-serif;
  font-weight: 600;
  line-height: normal;
  ${({ theme }) =>
    theme.widgetWidth < 800 &&
    `display: block;
     padding: 2px 5px;
     font-size: .6rem;
     min-width: 30%;`}
`;

const Max = styled.div`
  background-color: #be1717;
  padding: 2px 10px;
  font-size: 12px;
  min-width: 53px;
  border-bottom-left-radius: 7px;
  line-height: normal;
  ${({ theme }) =>
    theme.widgetWidth < 800 &&
    `display: block;
     padding: 2px 5px;
     font-size: .6rem;
     min-width: 30%;`}
`;

const StyledMinMax = styled.div`
  display: block;
  padding: 2px 10px;
  color: #fff;
  font-size: 12px;
  min-width: 53px;
  position: absolute;
  right: -10px;
  top: -2px;
  z-index: 3;
  font-family: Lato, sans-serif;
  font-weight: 600;
`;

const MinMaxTag = ({ min, max }) => {
  return (
    <StyledMinMax>
      <Min data-test="minmax-min">MIN: {roundTo(min, 2)}</Min>
      <Max data-test="minmax-max">MAX: {roundTo(max, 2)}</Max>
    </StyledMinMax>
  );
};

export default MinMaxTag;
